<template>
  <Popup :ref="(el) => popup = el"
         @onClose="hide"
         title=""
  >
    <form class="requisites">
      <div class="requisites__container">

        <div class="requisites__block">
          <div class="requisites__label requisites__label--start text-capitalize-first">
            {{ $t("labels.name") }}
          </div>
          <div class="requisites__content">
            <FormInputWrapper v-slot="parentProps" field="name" form="group">
              <input :class="parentProps.class" v-model="form.name" type="text" class="form-control " id="name">
            </FormInputWrapper>
          </div>
        </div>

        <div class="requisites__block" v-if="user.isTrafficGroupOnReqsEnabled">
          <div class="requisites__label requisites__label--start text-capitalize-first">
            {{ $t("labels.traffic_groups") }}
          </div>
          <div class="requisites__content">
            <FormInputWrapper v-slot="parentProps" field="trafficGroupIds" form="group">
              <TrafficGroupMultiselect  :class="parentProps.class" :multiple="true"  v-model="form.trafficGroups">
              </TrafficGroupMultiselect>
            </FormInputWrapper>
          </div>
        </div>

      </div>

      <div class="requisites__controls">
        <button class="btn" type="button" @click.prevent="hide">
          <span class="text-capitalize-first">{{ $t('button.cancel') }}</span>
        </button>
        <LoaderButton :on-click="save" class="btn btn--accept">
          <span class="text-capitalize-first">{{ $t('button.save') }}</span>
        </LoaderButton>
      </div>
    </form>
  </Popup>
</template>
<script lang="ts">
import {computed, defineComponent, onMounted, PropType, ref, watch} from 'vue'
import {reactive, toRefs} from '@vue/reactivity';
import Popup from "@/apps/public/components/Popup.vue";
import {$t, helper} from "@/service/CommonHelper";
import LoaderButton from "@/apps/public/components/LoaderButton.vue";
import {api} from "@/service/APIClient";
import CopyButton from "@/apps/public/components/CopyButton.vue";
import {useStore} from "vuex";
import FormInputWrapper from "@/components/FormInputWrapper.vue";
import Multiselect from "vue-multiselect";
import PayMethodIcon from "@/components/PayMethodIcon.vue";
import TrafficGroupMultiselect from "@/components/TrafficGroupMultiselect.vue";
import RequisiteGroupFormDTO from '@/models/form/RequisiteGroupFormDTO';
import RequisiteGroupUpdateRequestDTO from "@/models/request/RequisiteGroupUpdateRequestDTO";


export default defineComponent({
  emits: ['updated'],
  methods: {$t},
  components: {
    TrafficGroupMultiselect,
    PayMethodIcon,
    FormInputWrapper,
    LoaderButton,
    CopyButton,
    Popup,
    Multiselect
  },
  setup(props, {emit}) {
    const store = useStore()
    const popup = ref<InstanceType<typeof Popup> | null>(null)
    const state = reactive({
      form: {} as RequisiteGroupFormDTO,
    });

    const show = (dto: RequisiteGroupFormDTO) => {
      helper.clearErrors('group')

      state.form = dto

      popup.value?.show()
    }


    const hide = () => {
      popup.value?.hide()
    }


    const save = async () => {
      const data = {
        ...state.form,
        trafficGroupIds: state.form.trafficGroups.map(item => item.id)
      } as RequisiteGroupUpdateRequestDTO;

      try {
        if (state.form.id) {
          await api.traderRequisiteGroupUpdate(state.form.id, data)
        } else {
          await api.traderRequisiteGroupCreate(data)
        }
        emit('updated')
        hide()
      } catch (e) {
        helper.handleErrors('group', e)
        console.log(e);
      }
    }


    return {
      ...toRefs(state),
      popup,
      store,
      show,
      hide,
      helper,
      save,
      user: computed(() => store.getters.getUser),
    }
  },
  async beforeMount() {
  }
})
</script>
